export default __webpack_public_path__ + "static/media/6.90bd1072.jpg";